
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './storyMixerTerm.less';
import StoryMixerTerm from '../../../models/StoryMixerTerm';
import withLogFeatureUsage from 'react/containers/AnalyticContainer';
import StoryElementEventTypes from 'data/types/StoryElementEventTypes';

/**
 * Component that Represents an story mixer term button.
 * When hovered, executes setHoveredTerm callback to show the terms definition.
 * When clicked, executes handleClick callback to execute a new search for the selected term.
 */
class StoryMixerTermView extends Component {
	constructor() {
		super();
		this.state = { isTermSelected: false };
		this.handleTermClick = this.handleTermClick.bind(this);
	}

	/**
	 * Executes attached callback to search for the selected term.
	 * @memberof StoryMixerTermView
	 */
	handleTermClick() {
		this.props.onClick(); //this is required for logfeatureusage 
		this.props.handleClick(this.props.storyMixerTermData.searchValue);
		this.toggleSelectedTerm();
	}

	toggleSelectedTerm() {
		this.setState({ isTermSelected: !this.state.isTermSelected });
	}

	renderTermText() {
		return (
			<span className={'story-mixer-term-text'}>
				{this.props.storyMixerTermData.name}
			</span>
		);
	}

	render() {
		return (			
				<div className={`story-mixer-term clickable ${this.state.isTermSelected ? 'story-mixer-term-active' : ''}`}
					onClick={this.handleTermClick}
					onMouseEnter={() => { this.props.setHoveredTerm(this.props.storyMixerTermData) }}
					onMouseLeave={() => { this.props.setHoveredTerm() }}
				>
					{this.props.storyMixerTermData && this.renderTermText()}
				</div>			
		);
	}
}

StoryMixerTermView.propTypes = {
	storyMixerTermData: PropTypes.instanceOf(StoryMixerTerm).isRequired,
	/* Callback that executes the search for the clicked on term */
	handleClick: PropTypes.func.isRequired,
	setHoveredTerm: PropTypes.func.isRequired,
	onClick: PropTypes.func
}
export { StoryMixerTermView };

//Default export now includes a wrapper for logging.
export default withLogFeatureUsage(StoryMixerTermView, StoryElementEventTypes.STORYELEMENTS_TERM_CLICKED, (props) => props.storyMixerTermData.name);



// WEBPACK FOOTER //
// ./src/react/views/storyMixer/StoryMixerTermView.jsx